import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

const fmt = n => Number(n || 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const statusBadge = s => {
  const map = { Paid: 'badge-green', Unpaid: 'badge-orange', Overdue: 'badge-red', Partial: 'badge-blue' };
  return <span className={`badge ${map[s] || 'badge-gray'}`}>{s}</span>;
};

export default function Billing() {
  const [bills, setBills] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [barangays, setBarangays] = useState([]);
  const [filters, setFilters] = useState({ barangay_id: '', status: '', period: '', search: '' });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    const params = {};
    if (filters.barangay_id) params.barangay_id = filters.barangay_id;
    if (filters.status) params.status = filters.status;
    if (filters.period) params.period = filters.period;
    if (filters.search) params.search = filters.search;
    api.get('/bills', { params }).then(r => { setBills(r.data.bills); setPeriods(r.data.periods); setLoading(false); });
  };

  useEffect(() => { api.get('/barangays').then(r => setBarangays(r.data)); }, []);
  useEffect(load, [filters.barangay_id, filters.status, filters.period, filters.search]); // eslint-disable-line

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{margin:0}}>Billing</h1>
        <Link to="/billing/generate" className="btn btn-primary">Generate Bills</Link>
      </div>
      <div className="filters">
        <input className="input" style={{width:220}} placeholder="Search consumer..." value={filters.search} onChange={e => setFilters(f => ({...f, search: e.target.value}))} />
        <select className="input" style={{width:180}} value={filters.barangay_id} onChange={e => setFilters(f => ({...f, barangay_id: e.target.value}))}>
          <option value="">All Barangays</option>
          {barangays.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <select className="input" style={{width:150}} value={filters.status} onChange={e => setFilters(f => ({...f, status: e.target.value}))}>
          <option value="">All Status</option>
          <option>Unpaid</option><option>Paid</option><option>Overdue</option><option>Partial</option>
        </select>
        <select className="input" style={{width:150}} value={filters.period} onChange={e => setFilters(f => ({...f, period: e.target.value}))}>
          <option value="">All Periods</option>
          {periods.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>
      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card table-wrap">
          <table>
            <thead><tr><th>Consumer</th><th>Barangay</th><th>Period</th><th className="text-right">Consumption</th><th className="text-right">Charge</th><th className="text-right">Total</th><th>Status</th></tr></thead>
            <tbody>
              {bills.map(b => (
                <tr key={b.id} style={{cursor:'pointer'}} onClick={() => navigate(`/payments?consumer_id=${b.consumer_id}`)}><td>{b.consumer_name}</td><td>{b.barangay_name}</td><td>{b.billing_period}</td><td className="text-right">{b.consumption} cu.m.</td><td className="text-right">PHP {fmt(b.water_charge)}</td><td className="text-right">PHP {fmt(b.total_amount)}</td><td>{statusBadge(b.status)}</td></tr>
              ))}
            </tbody>
          </table>
          <div style={{color:'#666', fontSize:13, marginTop:8}}>{bills.length} bills</div>
        </div>
      )}
    </div>
  );
}
